import fromAnyToString from './fromAnyToString';

const START = 0;
const END = 10;

const fromStringToXs = (string) => fromAnyToString(string).split('').fill('x', START, END).join('');

// noinspection JSUnusedGlobalSymbols
export default fromStringToXs;
